"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var updateBanners = function updateBanners(banners) {
  return function (dispatch) {
    var action = {
      type: _types.UPDATE_BANNER,
      payload: banners
    };
    dispatch(action);
  };
};
var _default = exports["default"] = updateBanners;